import { Injectable } from "@angular/core";
import { HeadersService } from "../../shared/utilities/HeadersService";
import { BaseRestService } from "../../shared/services/BaseRestService";
import { IntegrationService } from "../../shared/services/integration.service";
import { FirstParties } from "../models/FirstParties";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PayeeNamesService {
  mmExperienceApiPath: string = 'api/ria.MoneyMovementExperience';

  constructor(
    private headersService: HeadersService,
    private baseService: BaseRestService,
    private integrationService: IntegrationService
  ) { }

  getPayeeNames(subaccount: string, transactionType: string
    ): Observable<FirstParties> {
      const serviceUrl = `${this.integrationService.JfkEnv.BaseUrl}${this.mmExperienceApiPath}/v1/PayeeNames?transactionType=${transactionType}`;
      const headers = this.getHeadersWithClientId(subaccount);
      return this.baseService.get<FirstParties>(serviceUrl, headers, true);
    }

  getHeadersWithClientId(
    subaccount:string
  ): {[name: string]: string;} {
    let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    headers['Schwab-Client-Ids'] = `1=${subaccount}`;
    return headers;
  }
}